import Box from '@mui/material/Box';
import { styled, Theme } from '@mui/material';
import { Row } from '../Layout';
import { FC } from 'react';

type PaletteColor =
  | 'primary'
  | 'secondary'
  | 'error'
  | 'warning'
  | 'info'
  | 'success';

type Props = {
  currentStep: number;
  numberOfSteps: number;
  color?: PaletteColor | (string & {});
};

const resolveColor = (theme: Theme, color?: PaletteColor | (string & {})) => {
  if (!color) return theme.palette.secondary.main;
  if (
    color in theme.palette &&
    'main' in (theme.palette[color as PaletteColor] ?? {})
  ) {
    return theme.palette[color as PaletteColor].main;
  }
  return color;
};

const Step = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isFutureStep' && prop !== 'color',
})<{ isFutureStep?: boolean; color?: PaletteColor | (string & {}) }>(
  ({ theme, isFutureStep, color }) => ({
    height: 4,
    width: 64,
    borderRadius: '100px',
    backgroundColor: isFutureStep
      ? theme.palette.grey[200]
      : resolveColor(theme, color),
  }),
);

const HorizontalStepper: FC<Props> = ({
  currentStep,
  numberOfSteps,
  color,
}) => {
  return (
    <Row spacing="sm">
      {Array.from({ length: numberOfSteps }, (_, i) => i).map((stepNumber) => (
        <Step
          key={stepNumber}
          isFutureStep={currentStep < stepNumber}
          color={color}
        />
      ))}
    </Row>
  );
};

export default HorizontalStepper;
